// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlanPackageEditorHeaderQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PlanPackageEditorHeaderQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, name: string } };


export const PlanPackageEditorHeaderDocument = gql`
    query PlanPackageEditorHeader($id: ID!) {
  planPackage(id: $id) {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __usePlanPackageEditorHeaderQuery__
 *
 * To run a query within a React component, call `usePlanPackageEditorHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanPackageEditorHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanPackageEditorHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlanPackageEditorHeaderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables> & ({ variables: PlanPackageEditorHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>(PlanPackageEditorHeaderDocument, options);
      }
export function usePlanPackageEditorHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>(PlanPackageEditorHeaderDocument, options);
        }
// @ts-ignore
export function usePlanPackageEditorHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>;
export function usePlanPackageEditorHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlanPackageEditorHeaderQuery | undefined, PlanPackageEditorHeaderQueryVariables>;
export function usePlanPackageEditorHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>(PlanPackageEditorHeaderDocument, options);
        }
export type PlanPackageEditorHeaderQueryHookResult = ReturnType<typeof usePlanPackageEditorHeaderQuery>;
export type PlanPackageEditorHeaderLazyQueryHookResult = ReturnType<typeof usePlanPackageEditorHeaderLazyQuery>;
export type PlanPackageEditorHeaderSuspenseQueryHookResult = ReturnType<typeof usePlanPackageEditorHeaderSuspenseQuery>;
export type PlanPackageEditorHeaderQueryResult = Apollo.QueryResult<PlanPackageEditorHeaderQuery, PlanPackageEditorHeaderQueryVariables>;